import { Injectable, OnDestroy, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CammeraStatusService implements OnDestroy {

  hasCamera = signal<boolean | null>(null);

  constructor() {
    this.init();
  }

  private async init() {
    // 1. 網頁載入時主動偵測一次
    await this.updateCameraStatus();

    // 2. 監聽硬體變動
    if (navigator.mediaDevices) {
      navigator.mediaDevices.addEventListener('devicechange', this.updateCameraStatus.bind(this));
    }
  }

  /**
   * 主動請求攝影機權限
   * 這會觸發瀏覽器的詢問視窗
   */
  async requestCameraPermission() {
    try {
      // 請求媒體流，這會彈出視窗
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      // 使用者點選「允許」
      console.log('✅ 使用者已允許開啟攝影機');
      this.hasCamera.set(true);

      // 取得權限後立即關閉串流，以免攝影機燈號一直亮著
      stream.getTracks().forEach(track => track.stop());

    } catch (error: any) {
      // 使用者點選「拒絕」或是系統沒有攝影機
      console.error('❌ 使用者拒絕或攝影機開啟失敗', error);

      if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
        this.hasCamera.set(false);
      } else {
        // 其他錯誤（如設備被占用）
        this.hasCamera.set(false);
      }
    }
  }

  // 修改原本的 updateCameraStatus 邏輯
  async updateCameraStatus(): Promise<boolean | null> {
  try {
    if (navigator.permissions && navigator.permissions.query) {
      const permission = await navigator.permissions.query({ name: 'camera' as any });

      if (permission.state === 'granted') {
        this.hasCamera.set(true);
        return true; // ✅ 回傳 boolean
      } else if (permission.state === 'denied') {
        this.hasCamera.set(false);
        return false; // ✅ 回傳 boolean
      } else {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const hasVideoDevice = devices.some(device => device.kind === 'videoinput');
        const status = hasVideoDevice ? null : false;
        this.hasCamera.set(status);
        return status; // ✅ 回傳 null 或 false
      }
    }
    // 如果不支援 permissions API
    return false; 
  } catch (error) {
    this.hasCamera.set(false);
    return false; // ✅ 發生錯誤時回傳 false
  }
}
  /**
 * 這是外部元件調用的主要方法：
 * 「先偵測，非 granted 才請求」
 */
  async triggerCameraApproval() {
    const status = await this.updateCameraStatus();

    // 只有在狀態是 null (prompt) 且有硬體時，才主動發起 getUserMedia
    if (status === null) {
      console.log('🔍 偵測到權限尚未決定，準備發起請求...');
      await this.requestCameraPermission();
    } else if (status === true) {
      console.log('✅ 已經有權限，不需重複請求');
    } else {
      console.log('❌ 權限已被拒絕，無法請求，請引導使用者至瀏覽器設定開啟');
    }
  }
  ngOnDestroy() {
    navigator.mediaDevices.removeEventListener('devicechange', this.updateCameraStatus.bind(this));
  }
}
